import { render } from "./buttonManage.vue?vue&type=template&id=3efbcec3"
import script from "./buttonManage.vue?vue&type=script&lang=js"
export * from "./buttonManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__